'use client'

import ComingSoon from '@/screens/ComingSoon'

/** Any other address, shown inside the top bar (signed-in only), as before. */
export default function NotFoundPage() {
  return <ComingSoon title="Page not found" />
}
